<template>
  <span class="field__switch">
    <input v-bind="$attrs"
      type="checkbox"
      role="switch"
      :checked="modelValue"
      @change="$emit('update:modelValue', $event.target.checked)">
    <span class="field__switch-text">{{ text }}</span>
    <span class="field__track"
      aria-hidden="true" />
  </span>
</template>

<script>
export default {
  name: 'switch-input',
  inheritAttrs: false,
  emits: ['update:modelValue'],
  props: {
    modelValue: { type: Boolean, default: false },
    text: { type: String, default: '' },
  },
}
</script>

<style lang="scss" src="./switch.scss"></style>
